import React from "react";
import Travel from "../components/TravelSuggestion/Travel";

const TravelSuggestion = () => {
    return <Travel />;
};

export default TravelSuggestion;
